export function recruiterKey(row) {
  const k =
    row._user_id ??
    row.user_id ??
    row.recruiter_id ??
    row.user_unique_id;
  if (k !== undefined && k !== null && k !== "") {
    return String(k);
  }
  return row.user_name != null && row.user_name !== ""
    ? String(row.user_name)
    : "";
}

export function managerKey(row) {
  const k =
    row._manager_id ??
    row.manager_id ??
    row.user_manager_id ??
    row.manager_unique_id;
  if (k !== undefined && k !== null && k !== "") {
    return String(k);
  }
  const name = String(row.manager_name ?? "").trim();
  return name && name !== "N/A" ? name : "";
}

/** Rows matching recruiter and/or manager dropdown filters. */
export function filterPipelineRows(rows, recruiterFilter, managerFilter) {
  const list = Array.isArray(rows) ? rows : [];
  return list.filter((r) => {
    if (recruiterFilter && recruiterKey(r) !== recruiterFilter) return false;
    if (managerFilter && managerKey(r) !== managerFilter) return false;
    return true;
  });
}
